import dynamic from "next/dynamic";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";

import particles_placeholder from "@public/about_us/particles_placeholder.png";

const Spline = dynamic(
  () =>
    import("@baseComponents/SplineWrapper").then(mod => ({
      default: mod.SplineWrapper,
    })),
  {
    ssr: false,
    loading: () => <div />,
  },
);

type SplineStatus = "loading" | "loaded" | "displayPlaceholder";

export function Animation() {
  const [status, setStatus] = useState<SplineStatus>("loading");

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (status === "loading") {
        setStatus("displayPlaceholder");
      }
    }, 5000);

    return () => clearTimeout(timeout);
  }, [status]);

  const handleLoad = () => setStatus("loaded");
  const handleError = () => setStatus("displayPlaceholder");
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.1,
        rootMargin: "50px",
      },
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div ref={containerRef} className="sticky top-32 aspect-square">
      {status === "displayPlaceholder" || !isVisible ? (
        <Image src={particles_placeholder} alt="" className="w-full h-auto" />
      ) : (
        <Spline
          scene="/about_us/particles.splinecode"
          onLoad={handleLoad}
          onError={handleError}
        />
      )}
    </div>
  );
}
